import { createContext, useContext } from "react";
import type { Item } from "../../../api/menu";
import { lunchRoomLeft } from "../../../lib/lunchCatalog";

// Колко още могат да се добавят от копие на дневно меню — по порциите на
// менюто му и с ЦЯЛАТА кошница (основните редове и добавките). Дава го
// „Маркиране"; без него (редакторът) — само бройката на самата карта.
export const LunchRoomContext = createContext<((item: Item) => number) | null>(null);

export const useLunchRoomOf = () => {
  const roomOf = useContext(LunchRoomContext);
  return (item: Item, quantity: number) => (roomOf ? roomOf(item) : lunchRoomLeft(item, quantity));
};
